import { callAsync } from './call-async.js';
import { showModal } from '../core/bootstrap-helpers.js';
import { totalCharges, loadAltKitBuilderItemsModal, getAltKitBuilderItems } from './post-onload.js';

export function initAsyncHandlers() {
    $('body').on('keyup', '.async-keyup', function(e){
        var $self = $(e.target).closest('.async-keyup');
        
        var f_url = $self.attr('async-url');
        if (f_url == null) {
            return;
        }
        var form_id = $self.attr('async-form-id') ?? null;
        var f_target = $self.attr('async-target-id') != undefined ? $('#' + $self.attr('async-target-id')) : null;
        var f_loading = $self.attr('async-loading-msg') ?? null;
        var f_callback = $self.attr('async-callback') ?? null;
        var f_abortVar = $self.attr('async-abort-tag') ?? null;
        callAsync({
                url: f_url,
                $target: f_target,
                postData: form_id,
                callback: f_callback,
                caller: $self,
                abortVar: f_abortVar,
                loadingMsg: f_loading
        });
    });

    $('body').on('click', '.async-button', function(e){
        var $self = $(e.target).closest('.async-button');
        var f_url = $self.attr('async-url');
        if (f_url == null) {
            return;
        }
        var form_id = $self.attr('async-form-id') ?? null;
        var f_target = $self.attr('async-target-id') != undefined ? $('#' + $self.attr('async-target-id')) : null;
        var f_callback = $self.attr('async-callback') ?? null;
        var f_loading = $self.attr('async-loading-msg') ?? null;
        var f_append = $self.attr('async-append') ?? null;
        if ($self.attr('async-disable-button') !== undefined) {
            $self.prop('disabled', true);
        };
        // If the button loads into a modal (e.g. the navbar/sidebar "+" category
        // drill-downs), open that modal and stop the click bubbling to an ancestor
        // link so it doesn't navigate away instead.
        if (f_target && f_target.length) {
            var $modal = f_target.closest('.modal');
            if ($modal.length) {
                e.preventDefault();
                e.stopPropagation();
                showModal($modal);
            }
        }
        callAsync({
                url: f_url,
                $target: f_target,
                postData: form_id,
                loadingMsg: f_loading,
                append: f_append,
                disabledBtnId: $self.attr('id'),
                callback: f_callback,
                caller: $self
        });
    });

    $('body').on('change', '.async-sel', function(e){
        var $self = $(e.target).closest('.async-sel');
        var f_url = $self.attr('async-url');
        if (f_url == null) {
            return;
        }
        var f_value = $self.val();
        var form_id = $self.attr('async-form-id') ?? null;
        if ($self.attr('async-target-id') != undefined) {
            var f_target = $('#' + $self.attr('async-target-id'));
        } else if ($self.attr('async-target')) {
            var elems = $self.attr('async-target');
            var path = elems.split(' > ');
            var pr = $self.closest('.' + path[0]);
            var f_target = pr.find('.' + path[1]);
        } else {
            var f_target  = null;
        }
        var f_callback = $self.attr('async-callback') ?? null;
        var f_append = $self.attr('async-append') ?? null;
        callAsync({
                url: f_url,
                $target: f_target,
                postData: (form_id ?? {value: f_value}),
                callback: f_callback,
                caller: $self,
                append: f_append
        });
    });

    $('body').on('click', '.click-get-alt-items', function(e){
        // Ignore clicks on the catalog link and on interactive controls that
        // now live inside the clickable cell (e.g. the size selector), so they
        // don't also trigger the alternate-parts modal.
        if ($(e.target).closest('a, select, option, input, label, .kit-size-control').length) {
            return;
        }
        loadAltKitBuilderItemsModal(e);
        getAltKitBuilderItems();
    });

    $('body').on('click change', '.replace-contents-trigger', function(e){
        var $self = $(e.target).closest('.replace-contents-trigger');
        if ($self.is('select')) {
            $self.attr('encoded-data', $self.find(':selected').attr('encoded-data'));
        }
        if (
            $self.attr('target-id') == 'undefined' ||
            $self.attr('method') == 'undefined' ||
            $self.attr('template') == 'undefined' ||
            $self.attr('encoded-data') == 'undefined'  ||
            e.type == 'click' && $self.is('select')
        ) {
            return;
        }
        var $tar = $('#' + $self.attr('target-id'));
        var cpostData = {};
        cpostData.triggered_by = $self.attr('triggered_by') ?? 'user';
        cpostData.template = $self.attr('template');
        cpostData.EncodedData = $self.attr('encoded-data');
        callAsync({
                url: $self.attr('method'),
                $target: $tar,
                postData: cpostData,
                callback: function(){$tar.trigger('change');}
        });
    });

    $('body').on('change keyup click', '.subtotal-trigger', function(e){
        totalCharges($(e.target).closest('.total-elements'));
    });

    $('body').on('click', '.click-reset-defaults', function(e){
        var $self = $(e.target).closest('.click-reset-defaults');
        var to_reset_class = $self.attr('reset-class');
        $(document).find('.' + to_reset_class).each(function(){
            if ($(this).attr('default-value') != undefined) {
                $(this).val($(this).attr('default-value'));
                $(this).trigger('change');
            }
        });
    });

    $('body').on('click', '.click-clear-inputs', function(e){
        var $self = $(e.target).closest('.click-clear-inputs');
        var to_reset_class = $self.attr('clear-class');
        $(document).find('.' + to_reset_class).each(function(){
            if ($(this).attr('cleared-value') != undefined) {
                $(this).val($(this).attr('cleared-value'));
            } else {
                $(this).val('');
            }
            $(this).trigger('change');
        });
    });

    $('body').on('click', '.remove-row-button', function(e){
        var $self = $(e.target).closest('.remove-row-button');
        $self.closest('tr').remove();
        if ($self.attr('call-function') != undefined) {
            window[$self.attr('call-function')]();
        }
    });

    $('body').on('click', '.remove-row-and-next-button', function(e){
        var $self = $(e.target).closest('.remove-row-and-next-button');
        var $row = $(e.target).closest('tr');
        $row.next().remove();
        $row.remove();
        if ($self.attr('call-function') != undefined) {
            window[$self.attr('call-function')]();
        }
    });

    $('body').on('click', '.clone-inputs', function (e) {
          var $self = $(e.target).closest('.clone-inputs');
          var $cloned = $('#' + $self.attr('clonable-inputs-id'));
          var $parent = $cloned.parent();
          var html = $cloned.html();
          $parent.append(html);
    });

    $('body').on('change', '.change-select', function (e) {
        if (window.changeSelect) {
            return;
        }
        window.changeSelect = true;
        var $self = $(e.target).closest('.change-select');
        $self.attr('changed-manually', '1');
        var ids = $self.attr('change-select-ids').split(',');
        var $sel = null;
        for (let i = 0; i < ids.length; i++) {
            $sel = $('#' + ids[i]);
            if (!$sel.length || $sel.attr('changed-manually')) {
                continue;
            }
            $sel.val($self.val());
            $sel.attr('triggered_by', 'system');
            $sel.trigger('change');
        }
        window.changeSelect = false;
    });

    $('body').on('click', 'a[href^="pro-rebates-modal"]', function (e) {
        e.preventDefault();
        callAsync({
            url: 'insight/get_pro_rebates_modal_content',
            $target: $('#prModal').find('.modal-body'),
        });
        showModal($('#prModal'));
    });

    $('body').on('click', 'a[href^="k2r-entries-modal"]', function (e) {
        e.preventDefault();
        callAsync({
            url: 'insight/get_k2r_entries_modal_content',
            $target: $('#k2rModal').find('.modal-body'),
        });
        showModal($('#k2rModal'));
    });
}
